import { render, staticRenderFns } from "./indexTitle.vue?vue&type=template&id=7a22d7e0&scoped=true&"
import script from "./indexTitle.vue?vue&type=script&lang=js&"
export * from "./indexTitle.vue?vue&type=script&lang=js&"
import style0 from "./indexTitle.vue?vue&type=style&index=0&id=7a22d7e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a22d7e0",
  null
  
)

export default component.exports